// Ce fichier définit les valeurs par defaut du state dans le GlobalContext
// ex: import INITIAL_STATE from '/contexts/INITIAL_STATE';
import {getPage,getFiltersActivities, parseFiltersActivities} from '../../../helpers/navigationHelper';

import I_STATE from './I_STATE';


const currentDate = new Date();

// du 01 jan au 31 dec
const from_01Jan = currentDate.getFullYear()+'-01-01';
const to_31dec = currentDate.getFullYear()+'-12-31';

// du jourJ à jourJ+1an
const fromNow = `${currentDate.getFullYear()}-${currentDate.getMonth() < 9 ? '0' : ''}${currentDate.getMonth()+1}-${currentDate.getDate() < 10 ? '0' : ''}${currentDate.getDate()}`;
const to = currentDate.getMonth() === 1 && currentDate.getDate() === 28
  ? `${currentDate.getFullYear()+1}-${currentDate.getMonth() < 9 ? '0' : ''}${currentDate.getMonth()+1}-${currentDate.getDate() < 10 ? '0' : ''}${currentDate.getDate() - 1}`
  : `${currentDate.getFullYear()+1}-${currentDate.getMonth() < 9 ? '0' : ''}${currentDate.getMonth()+1}-${currentDate.getDate() < 10 ? '0' : ''}${currentDate.getDate()}`;

// du mois courant à year+1
// ex : 2025-01-01 au 2025-12-31
const currentMonth = currentDate.getMonth();  // 0 - 11
const currentMonthFormatted = `${currentMonth < 9 ? '0' : ''}${currentMonth + 1}`;
const toMonth = currentMonth > 0 ? currentMonth - 1 : 11;
const toMonthFormatted = `${toMonth < 9 ? '0' : ''}${toMonth + 1}`;
const toYear = currentMonth > 0 ? currentDate.getFullYear() + 1 : currentDate.getFullYear();
const toDayFormatted = toMonth === 1 ? '28' :
  (toMonth === 0 || toMonth === 2  || toMonth === 4 || toMonth === 6 ||
    toMonth === 7 || toMonth === 9 || toMonth === 11 ? '31' : '30');
const from_01CurrentMonth = currentDate.getFullYear()+'-'+currentMonthFormatted+'-01';
const to_31PreviousMonth = toYear+'-'+toMonthFormatted+'-'+toDayFormatted;

// filters
const filtersActivities = parseFiltersActivities();
const INITIAL_STATE: I_STATE = {
  page:getPage(),
  from_date: filtersActivities?.from_date !== '' ? filtersActivities?.from_date : from_01CurrentMonth,
  to_date: filtersActivities?.to_date !== '' ? filtersActivities?.to_date : to_31PreviousMonth,
  activity_types: filtersActivities?.activity_types ||[],
  directions_ops: [],
  hubs_ops: [],
  directions_hr: filtersActivities?.directions_hr || [],
  hubs_hr: filtersActivities?.hubs_hr || [],
  collaborators: filtersActivities?.collaborators || [],
  skills: filtersActivities?.skills || [],
  functions: filtersActivities?.functions || [],
  billing_customers: filtersActivities?.billing_customers || [],
  audited_customers: filtersActivities?.audited_customers || [],
  referentials: filtersActivities?.referentials || [],
  referential_types: filtersActivities?.referential_types || [],
  of_number: filtersActivities?.of_number !== '' ? filtersActivities?.of_number : '',
};
export default INITIAL_STATE;
